import React from "react";
const BrandContext = React.createContext({
    marketing: { brandColor: '#ffffff' }
});
export default BrandContext;